import React from "react";
import MuiBox from "../MuiBox";
import MuiTypography from "../MuiTypography";

const FormError = ({ errorMsg, ...rest }) => {
  let { sx, ...restProps } = rest
  return (
    <MuiBox sx={{ marginTop: "6px", display: 'flex', alignItems: "flex-start", ...sx }} {...restProps}>
      <MuiTypography
        // sx={{ marginLeft: "5px" }}
        variant="12"
        color="#E12121"
      >
        {errorMsg}
      </MuiTypography>
    </MuiBox>
  );
};

export default FormError;
